import axios from '@axios'

export default function (route = '') {
  const PREFIX = `parcelamentos/${route}`

  return {
    getObservacoes(id) {
      return axios.get(`${PREFIX}/parcela/${id}/observacao`)
    },

    salvarObservacao(observacao) {
      return axios.post(`${PREFIX}/parcela/observacao/salvar`, observacao)
    },

    removerObservacao(id) {
      return axios.delete(`${PREFIX}/observacao/${id}/remover`)
    },

    baixarSelecionados(ids) {
      return axios.post(`${PREFIX}/baixar-selecionadas`, ids)
    },

    enviarEmailLote(nomeArquivo, payload) {
      let rotina = ''
      switch (route) {
        case 'das': rotina = 'ParcelamentoDas'; break
        case 'pgfn': rotina = 'ParcelamentoPgfn'; break
        case 'nao-previdenciario': rotina = 'ParcelamentoNaoPrevidenciario'; break
        case 'pert': rotina = 'ParcelamentoPert'; break
        case 'relp': rotina = 'ParcelamentoRelp'; break
        case 'simp-previdenciario': rotina = 'ParcelamentoSimplificadoPrevidenciario'; break
        case 'rfb': rotina = 'ParcelamentoRfb'; break
        default: rotina = 'ParcelamentoDas'; break
      }
      return axios.post(`parcelamentos/envio-email-lote/${rotina}?nomeArquivo=${nomeArquivo}`, payload)
    },

    baixarEmExcelEspecifico(dto) {
      return axios.post(`${PREFIX}/baixa-excel-selecionados`, dto)
    },

    getDocWhatsapp(id, parcelaId = null) {
      if (parcelaId) {
        return axios.get(`${PREFIX}/${id}/guia/${parcelaId}`)
      }
      return axios.get(`${PREFIX}/url-whatsapp/${id}`)
    },
  }
}
